<template>
  <div id="footer">
    <el-col :span="24" class="main">
      <el-col v-if="systemInfo" :offset="3" :span="18">
        <el-row class="row-footer-name"><span>{{ systemInfo ? systemInfo.name : "" }}</span></el-row>
        <div v-for="admin in systemInfo.admin_list" :key="admin.id">
          <el-row class="phone-row">
            <span>{{ `${admin.position} : ${admin.display_name}  ${admin.phone}` }}</span>
          </el-row>
        </div>
        <el-row class="phone-row"></el-row>
      </el-col>
    </el-col>
    <Language></Language>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Language from '@/components/Language'

  export default {
    name: "Footer",
    components: {
      Language
    },
    mounted: function () {
      this.$store.dispatch('settingschool/getSystemInfo', {})
    },
    computed: {
      ...mapState('settingschool', ['systemInfo']),
    }
  }
</script>
<style lang="scss">
  #footer .row-footer-name {
    color: #fff;
    margin-bottom: 15px;
    padding-top: 20px;
    font-size: 22px;
    font-weight: bold;
    height: 55px;
  }
  #footer .main {
    background-color: rgb(108, 117, 125, 0.7);
    bottom: 0
  }
  #footer .phone-row {
    color: #ffd;
    font-size: 17px;
    height: 25px;
    margin-bottom: 5px;
  }

  #footer {
    margin-top:30px;
    position: relative;
  }
</style>